import { env } from '@monorepo/env'
import { Context } from '@monorepo/utils/auth-types'
import { getApplicationName, getBundleId } from '@monorepo/utils/device-info'
import { auth, getIdTokenResult } from '@monorepo/utils/firebase'
import { Platform } from 'react-native'
import DeviceInfo from 'react-native-device-info'

export type GetContext = () => Promise<Context>

export const getContext: GetContext = async () => {
  const currentUser = auth().currentUser
  if (!currentUser) {
    throw new Error('No current user')
  }
  const result = await getIdTokenResult(currentUser, Platform.OS === 'web')

  const user = currentUser?.toJSON() as any
  const applicationName = getApplicationName()
  const brand = DeviceInfo.getBrand()
  const buildNumber = DeviceInfo.getBuildNumber()
  const bundleId = getBundleId()
  const deviceId = DeviceInfo.getDeviceId()
  const deviceType = DeviceInfo.getDeviceType()
  const manufacturerSync = DeviceInfo.getManufacturerSync()
  const model = DeviceInfo.getModel()
  const readableVersion = DeviceInfo.getReadableVersion()
  const systemName = DeviceInfo.getSystemName()
  const systemVersion = DeviceInfo.getSystemVersion()
  const uniqueIdSync = DeviceInfo.getUniqueIdSync()
  const version = DeviceInfo.getVersion()
  const hasNotch = DeviceInfo.hasNotch()
  const hasDynamicIsland = DeviceInfo.hasDynamicIsland()
  const isLandscapeSync = DeviceInfo.isLandscapeSync()
  const isTablet = DeviceInfo.isTablet()
  const isLowRamDevice = DeviceInfo.isLowRamDevice()
  const isDisplayZoomed = DeviceInfo.isDisplayZoomed()
  const platformOS = Platform.OS
  const platformVersion = Platform.Version
  const appVersion = env.EXPO_PUBLIC_VERSION_HEYQUILL_WEB || '1.0.0.0'
  const output = {
    user: {
      ...user,
      stsTokenManager: {
        ...user?.stsTokenManager,
        accessToken: result?.token,
      },
    },
    app: {
      applicationName,
      brand,
      buildNumber,
      bundleId,
      deviceId,
      deviceType,
      manufacturerSync,
      model,
      readableVersion,
      systemName,
      systemVersion,
      uniqueIdSync,
      version,
      hasNotch,
      hasDynamicIsland,
      isLandscapeSync,
      isTablet,
      isLowRamDevice,
      isDisplayZoomed,
      platformOS,
      platformVersion,
      appVersion,
    },
  }
  // console.log('Context', JSON.stringify(output, null, 2))
  return output
}
